export default "__VITE_ASSET__oXXNV436__"